import { useState } from "react"
import FirstPage from './FirstPage';
import SecondPage from './SecondPage';

export default () => {
    const [hasClicked, toggleHasClicked] = useState(false);

    return hasClicked ? <SecondPage /> :<FirstPage toggleHasClicked={toggleHasClicked} />;
}